import { render, staticRenderFns } from "./SenaEditionRanking.vue?vue&type=template&id=962286fe&"
import script from "./SenaEditionRanking.vue?vue&type=script&lang=js&"
export * from "./SenaEditionRanking.vue?vue&type=script&lang=js&"
import style0 from "./SenaEditionRanking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports